import { useLayoutEffect, useRef, useState } from "react"
import { usePopper } from "react-popper"
import { Placement } from "../types/types"


interface Props {
  placement: Placement
  margin: number
}
const useTooltip = ({placement,margin}:Props) => {
  const[isOpen, setisOpen] = useState<boolean>(false)
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement|null>(null)
  const [popperElement, setPopperElement] = useState<HTMLDivElement|null>(null)
  const [arrowElement, setArrowElement] = useState<HTMLDivElement|null>(null)
  const refPopper = useRef<HTMLDivElement>(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement:placement,
    modifiers: [
      {
        name: 'arrow',
        options: {
            element: arrowElement,
        }
      },
      {
        name: 'offset',
        options: {
          offset: [0, margin],
        }
      }
    ]
  })

  /* useLayoutEffect(() => {
    const clickHandler = ({ target }: any) => {
      if (null !== refPopper.current) {
        if (!isOpen || refPopper.current.contains(target)) return;
        setisOpen(false);
      }
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  }); */

  return {
    setReferenceElement,
    setPopperElement,
    setArrowElement,
    styles,
    attributes,
    refPopper,
    isOpen,
    setisOpen
  }
}

export default useTooltip